var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[(_vm.estadoAuth)?_c('div',[_c('v-app',[_c('NavBar'),_c('Navigation'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1):_c('div',{attrs:{"id":"salida"}},[_c('LoginUser')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }